import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { browserClient } from '../client/browser';
import {
    GetCalmPublicDeviceConsentResponse,
    GetCalmPublicNarratorsResponse,
    GetCalmPublicProgramResponse,
} from './types';

const headers = {
    ['x-calm-product']: 'ch',
};

function getConfig<T>(
    configOverrides: AxiosRequestConfig<T> = { headers: {} }
) {
    return {
        ...configOverrides,
        headers: {
            ...headers,
            ...configOverrides.headers,
        },
    };
}

export function createCalmPublicApi(
    // We can change this if we want to instead create an API for the server using a server client
    client: AxiosInstance = browserClient
) {
    const baseUri = process.env.NEXT_PUBLIC_CALM_API_BASEURL;
    return {
        getCalmPublicDeviceConsent: async (
            configOverrides?: AxiosRequestConfig
        ) => {
            const path = '/device/consent';
            return client.get<GetCalmPublicDeviceConsentResponse>(
                `${baseUri}${path}`,
                getConfig(configOverrides)
            );
        },
        getCalmPublicNarrators: async (
            narratorIds: string[],
            configOverrides?: AxiosRequestConfig
        ) => {
            const path = '/content/narrators/list';
            return client.get<GetCalmPublicNarratorsResponse>(
                `${baseUri}${path}`,
                {
                    ...getConfig(configOverrides),
                    params: { narrator_ids: JSON.stringify(narratorIds) },
                }
            );
        },
        getCalmPublicProgram: async (
            programId: string,
            configOverrides?: AxiosRequestConfig
        ) => {
            const path = `/content/programs/${programId}`;
            return client.get<GetCalmPublicProgramResponse>(
                `${baseUri}${path}`,
                getConfig(configOverrides)
            );
        },
    };
}
